import React from "react";
import Avatar, { IAvatar } from "../../Common/Avatars/Avatar";

export interface IAvatarNameListItem extends IAvatar {
  firstName: string;
  lastName: string;
}

export default function AvatarNameListItem(props: IAvatarNameListItem) {
  return (
    <div
      className={`flex w-full items-center gap-3 py-2 ${
        props.onClick ? "cursor-pointer" : ""
      }`}
      onClick={props.onClick}
    >
      <Avatar icon={props.icon} active={props.active} />
      <div className="text-small font-medium">{`${props.firstName} ${props.lastName}`}</div>
    </div>
  );
}
